module.exports = __webpack_public_path__ + "static/media/layer_3.ad604da6.svg";